import * as angular from 'angular';
angular.module('ib-commons-cookies-service-module', []); // @todo delete when refactor all apps
import './http-utils-services/ib-commons-http-utils-error-service';
import './http-utils-services/ib-commons-new-http-utils-error-service';
import './http-utils-services/ib-commons-http-utils-service';
import './http-utils-services/ib-commons-new-http-utils-service';
import './ib-commons-commercial-selling-data-utils';
import './ib-commons-component-utils';
import './ib-commons-currency-service';
import './ib-commons-documents-validator-service';
import './ib-commons-generate-url-service';
import './ib-commons-language-and-market-service';
import './ib-commons-utils-local-discounts';
import './ib-commons-utils-service';
import './ib-commons-permanent-user-service';
